import styled from 'styled-components'

import { applyIPadOnlyStyle, getResponsiveFontSizeCSS } from 'helpers/css'

export const Content = styled.div`
    font-family: Avenir;
    font-size: ${getResponsiveFontSizeCSS(12, 20)};
    line-height: 16px;
    color: #333;
    margin-top: 10px;
    ${applyIPadOnlyStyle(`color: white`, {
        min: 0,
        max: 1370,
        orientation: 'both',
    })}
`
